let registrationPromise = null;

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return Promise.resolve(null);
  if (registrationPromise) return registrationPromise;

  registrationPromise = navigator.serviceWorker.register("/sw.js", { scope: "/" })
    .then((registration) => {
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        worker?.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("hqs:service-worker-update"));
          }
        });
      });
      return registration;
    })
    .catch((error) => {
      console.warn("HQS Service Worker konnte nicht registriert werden:", error?.message || error);
      registrationPromise = null;
      return null;
    });

  return registrationPromise;
}

export async function getHqsServiceWorkerRegistration() {
  const registered = await registerServiceWorker();
  if (registered) return registered;
  try {
    return await navigator.serviceWorker.ready;
  } catch {
    return null;
  }
}

export async function unregisterServiceWorker() {
  if (!("serviceWorker" in navigator)) return false;
  const registration = await navigator.serviceWorker.getRegistration("/");
  registrationPromise = null;
  return registration ? registration.unregister() : false;
}
